import React from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { mockPaintings, paintingImage } from '../data/mockGalleryData';

const PaintingList = ({ isOpen, onClose, currentPaintingIndex, onPaintingSelect }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[80vh] overflow-hidden m-4">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-2xl font-bold text-gray-800">Gallery Collection</h2>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={20} />
          </Button>
        </div>
        
        <div className="p-4 overflow-y-auto max-h-[calc(80vh-80px)]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {mockPaintings.map((painting, index) => (
              <div
                key={painting.id}
                className={`cursor-pointer rounded-lg border-2 transition-all duration-300 hover:shadow-lg ${
                  index === currentPaintingIndex 
                    ? 'border-amber-500 bg-amber-50' 
                    : 'border-gray-200 hover:border-amber-300'
                }`}
                onClick={() => {
                  onPaintingSelect(index);
                  onClose();
                }}
              >
                <div className="aspect-[4/3] overflow-hidden rounded-t-lg">
                  <img
                    src={paintingImage(painting, 'thumb')}
                    loading="lazy"
                    alt={painting.title}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-gray-800 mb-1">
                    {painting.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-2">
                    by {painting.artist}
                  </p>
                  <p className="text-xs text-gray-500 line-clamp-2">
                    {painting.description}
                  </p>
                  {index === currentPaintingIndex && (
                    <div className="mt-2 text-xs text-amber-600 font-medium">
                      Currently Viewing
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaintingList;